<template>
    <div class="apprentice-simple-card">
        <b-tabs
            class="accounts-show-tab apprentice-tab"
            content-class="accounts-overview"
            fill>
            <b-tab class="new-users">
                <template v-slot:title>
                    {{ $t('common.not_found') }}
                </template>
                {{ $t('user_account.import.these_users_were_not_found_based_on_email_address') }}
                <design-2021-apprentice-data-table
                    class="not_found_table"
                    :items="newUsers"
                    :fields="headers">
                    <template
                        v-slot:cell(add_to_import)="data"
                        v-if="!lasConnectionIn">
                        <b-form-checkbox-group v-model="usersToAdd">
                            <b-form-checkbox :value="data.item"></b-form-checkbox>
                        </b-form-checkbox-group>
                    </template>
                    <template v-slot:cell(type)="data">
                        <span v-if="data.item.type === 'student'">{{ $t('user_account.import.student') }}</span>
                        <span v-else>docent</span>
                    </template>
                </design-2021-apprentice-data-table>
                <div v-if="lasConnectionIn">
                    <p variant="alarm">
                        {{
                            $t(
                                'user_account.import.add_these_users_manually_make_sure_they_do_not_already_exist_under_a_different_email_address',
                            )
                        }}
                    </p>
                </div>
                <div class="tools">
                    <b-button
                        class="btn-add btn-add-user"
                        v-if="!lasConnectionIn"
                        @click="addSelectedUsers()"
                        variant="primary">
                        {{ $t('common.add') }}
                    </b-button>
                </div>
            </b-tab>
            <b-tab class="existing-users">
                <template v-slot:title>
                    {{ $t('common.add') }}
                </template>
                {{ $t('user_account.import.these_users_were_found_based_on_email_address') }}
                <design-2021-apprentice-data-table
                    class="not_found_table"
                    :items="existingUsers"
                    :fields="headers">
                </design-2021-apprentice-data-table>
            </b-tab>
        </b-tabs>
        <div class="tools">
            <b-button
                class="btn-back-to-accounts"
                @click="backToAccounts"
                variant="outline-primary">
                {{ $t('user_account.import.back_to_accounts') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-accounts-import-validate-component',
    props: ['resultsIn', 'importIn', 'lasConnectionIn'],
    data() {
        return {
            newUsers: [],
            existingUsers: [],
            usersToAdd: [],
            headers: [
                {
                    key: 'add_to_import',
                    label: this.$t('common.choose'),
                },
                {
                    key: 'name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'preposition',
                    label: this.$t('common.infix'),
                    sortable: false,
                },
                {
                    key: 'surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('user_account.import.email_address'),
                    sortable: true,
                },
                {
                    key: 'external_id',
                    label: this.$t('common.student_number'),
                    sortable: true,
                },
                {
                    key: 'type',
                    label: 'type',
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        addSelectedUsers() {
            const data = {
                users: this.usersToAdd,
            };

            axios.post(this.routes.schoolAccountImportValidate(this.importIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        backToAccounts() {
            window.location.href = this.routes.schoolAccounts();
        },
    },

    mounted() {
        this.newUsers = this.resultsIn[0].map((user) => {
            user.type_name = 'user';
            return user;
        });
        this.usersToAdd = this.newUsers;
        this.existingUsers = this.resultsIn[1].map((user) => {
            return user;
        });
    },
};
</script>

<style scoped lang="scss">
.not_found_table ::v-deep {
    .add_to_import {
        .btn-user-selection-toggle {
            color: grayscale($primary);

            &.active {
                color: $primary;
            }
        }
    }
}

::v-deep .apprentice-data-table tbody .btn-new-paper {
    font-size: 28px;
}

.tools {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .btn {
        line-height: 1;
    }

    .btn-add-user {
        &:nth-child(2) {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
